'use client'

import React, { HTMLAttributes } from 'react'
import BaseOverlay, { AnimatedStyle, overlayStyle } from './BaseOverlay'
import Title from '@/components/Elements/Title'
import { cx, VariantProps } from 'class-variance-authority'
import MoreDetails from '@/components/Elements/MoreDetails'
import useDevice from '@/hooks/useDevice'

type MoreInfoOverlayProps = VariantProps<typeof overlayStyle> &
  Omit<HTMLAttributes<HTMLDivElement>, 'style'> & {
    style?: AnimatedStyle
    onClose?: () => void
    children?: React.ReactNode | React.ReactNode[]
    isFullWidth?: boolean
  }

export default function MoreInfoOverlay({
  onClose,
  children,
  isFullWidth,
  ...props
}: MoreInfoOverlayProps) {
  const device = useDevice()

  return (
    <BaseOverlay onClose={onClose} {...props}>
      <div className='flex h-full flex-col'>
        <div
          className={cx(
            'h-full flex-1 overflow-x-hidden overflow-y-auto pr-4',
            isFullWidth && device === 'desktop'
              ? 'column-fill-auto columns-2 gap-12'
              : '',
          )}
        >
          <Title as='h5' variant={'inverse'}>
            {children}
          </Title>
        </div>
        <div className='mt-4 flex w-full justify-center'>
          <MoreDetails
            lessDetails={true}
            onClick={onClose}
            variant={'inverse'}
          />
        </div>
      </div>
    </BaseOverlay>
  )
}
